export const ORDER_STATUSES = {
  PENDING_PAYMENT: {
    code: 1,
    label: 'Aguardando pagamento',
    color: '#FFA500'
  },
  PAYMENT_CONFIRMED: {
    code: 2,
    label: 'Pagamento confirmado',
    color: '#4169E1'
  },
  PREPARING_SHIPMENT: {
    code: 3,
    label: 'Preparando envio / separação',
    color: '#1E90FF'
  },
  COMPLETED: {
    code: 4,
    label: 'Entregue',
    color: '#778899'
  },
  CANCELLED: {
    code: 5,
    label: 'Cancelado',
    color: '#B22222'
  },
  IN_TRANSIT: {
    code: 6,
    label: 'A caminho',
    color: '#228B22',
    deliveryType: 1
  },
  READY_FOR_PICKUP: {
    code: 7,
    label: 'Pronto para Retirada',
    color: '#228B22',
    deliveryType: 2
  }
};

export const ORDER_STATUS = Object.fromEntries(
  Object.entries(ORDER_STATUSES).map(([key, { code }]) => [key, code])
);

const byCode = Object.fromEntries(
  Object.values(ORDER_STATUSES).map(status => [status.code, status])
);

export function normalizeOrderStatus(status) {
  if (status == null || status === '') return null;

  if (typeof status === 'string' && ORDER_STATUSES[status]) {
    return ORDER_STATUSES[status].code;
  }

  const parsed = Number(status);
  return Number.isNaN(parsed) ? null : parsed;
}

export function getOrderStatusLabel(status) {
  const code = normalizeOrderStatus(status);
  return byCode[code]?.label || 'Status desconhecido';
}

export function getOrderStatusColor(status) {
  const code = normalizeOrderStatus(status);
  return byCode[code]?.color || '#999999';
}

export function getOrderStatusOptions(deliveryType) {
  return Object.values(ORDER_STATUSES)
    .filter(
      ({ deliveryType: type }) => type == null || type == deliveryType
    )
    .map(({ code, label }) => ({ value: code, label }));
}
